import { makeStyles } from '@material-ui/core'

const styles = (underContestation = false) =>
  makeStyles((theme) => ({
    containerButton: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      alignItems: 'center',
      width: '100%',
    },
    containerIcon: {
      color: theme.palette.common.white,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      width: 20,
      height: 20,
    },
    categoryButton: {
      padding: 10,
      borderColor: theme.palette.custom.border,
      backgroundColor: theme.palette.common.white,
      boxShadow: 'none',
    },
    categoryIcon: {
      padding: 4,
    },
    categoryName: {
      fontWeight: 600,
    },
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
      [theme.breakpoints.down('xs')]: {
        gridTemplateColumns: 'repeat(1, 1fr)',
      },
    },
    gridItem: {
      display: 'flex',
    },
    boardScrollbar: {
      overflow: 'auto',
      paddingBottom: theme.spacing(2),
    },
    boardHeader: {
      backgroundColor: theme.palette.primary.main,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      padding: theme.spacing(2),
      textAlign: 'center',
      minHeight: 'fit-content',
      color: theme.palette.common.white,
      width: '100%',
      minWidth: `${
        theme.breakpoints.values.md - theme.breakpoints.values.sm
      }px`,
      [theme.breakpoints.down('xs')]: {
        minWidth: 'calc(100vw - 70px)',
      },
    },
    boardContent: {
      flex: 1,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
      paddingLeft: theme.spacing(2),
      paddingBlock: theme.spacing(2),
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.primary.main}`,
      overflow: 'hidden',
    },
    viewToggleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.spacing(2),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    activeViewButton: {
      color: theme.palette.primary.main,
    },
    scrollbar: {
      paddingRight: theme.spacing(2),
      height: '100%',
    },
    boardBody: {
      display: 'flex',
      flexDirection: 'column',
      gridGap: theme.spacing(1),
      width: '100%',
      alignItems: 'center',
    },
    notFoundActivity: {
      width: '100%',
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.default,
    },
  }))

export default styles
